module.exports = __webpack_public_path__ + "media/images/icon__close--rb-white@2x-ca692ff51589a04b8991b232d51bc259.png";